import { Inject, Injectable } from '@angular/core';
import { WINDOW } from '../../../util/window';

@Injectable({
  providedIn: 'root',
})
export class BrowserStorageService {
  constructor(@Inject(WINDOW) private readonly window: Window | any) {}

  public getSession<T>(key: string): T | null {
    if (this.window instanceof Window) {
      const data = this.window.sessionStorage.getItem(key);
      if (data) {
        return JSON.parse(data);
      }
    }
    return null;
  }

  public setSession<T>(key: string, value: T): T | null {
    if (this.window instanceof Window) {
      this.window.sessionStorage.setItem(key, JSON.stringify(value));
      return value;
    }
    return null;
  }

  public getLocal<T>(key: string): T | null {
    if (this.window instanceof Window) {
      const data = this.window.localStorage.getItem(key);
      if (data) {
        return JSON.parse(data);
      }
    }
    return null;
  }

  public setLocal<T>(key: string, value: T): T | null {
    if (this.window instanceof Window) {
      this.window.localStorage.setItem(key, JSON.stringify(value));
      return value;
    }
    return null;
  }

  public removeLocal(key: string): void | null {
    if (this.window instanceof Window) {
      this.window.localStorage.removeItem(key);
    }
    return null;
  }

  public addToArrayLocalStorage<T>(key: string, value: T): T[] | null {
    const sessions: T | null = this.getLocal(key);
    if (Array.isArray(sessions)) {
      return this.setLocal(key, [...sessions, value]);
    }
    return this.setLocal(key, [value]);
  }

  public addToArray<T>(key: string, value: T): T[] | null {
    const sessions: T | null = this.getSession(key);
    if (Array.isArray(sessions)) {
      return this.setSession(key, [...sessions, value]);
    }
    return this.setSession(key, [value]);
  }

  public removeSession(key: string): void | null {
    if (this.window instanceof Window) {
      this.window.sessionStorage.removeItem(key);
    }
    return null;
  }

  public removeAllSessions(): void | null {
    if (this.window instanceof Window) {
      for (const key in window.sessionStorage) {
        if (Object.prototype.hasOwnProperty.call(this.window.sessionStorage, key)) {
          this.removeSession(key);
        }
      }
    }
    return null;
  }
}
